// Copyright 2022, Imprivata, Inc.  All rights reserved.

type FeatureFlagEnv = 'dev' | 'cit' | 'int' | 'stg' | 'prod';

/**
 * Detects the feature-flag environment tier from the current URL.
 *
 * URL pattern:  <app>.<zone>.<env>.imprivata.<tld>
 * Examples:
 *   https://localhost:8080          → 'dev'
 *   https://patient.app.dev.imprivata.com  → 'dev'
 *   https://patient.app.int.imprivata.com  → 'int'
 *   https://patient.app.stg.imprivata.com  → 'stg'
 *   https://patient.app.imprivata.com      → 'prod'
 *
 * CIT (Playwright) mode: caller passes import.meta.env.MODE; if 'cit', returns 'cit'.
 */
export function detectFeatureFlagEnv(host: string, viteMode?: string): FeatureFlagEnv {
  if (viteMode === 'cit') {
    return 'cit';
  }
  if (host.includes('localhost')) {
    return 'dev';
  }
  const envRegex = /\w+\.\w+\.(\w+)\.\w+\.\w+/i;
  const match = envRegex.exec(host);
  if (match) {
    const candidate = match[1] as FeatureFlagEnv;
    const known: FeatureFlagEnv[] = ['dev', 'cit', 'int', 'stg'];
    if (known.includes(candidate)) {
      return candidate;
    }
  }
  return 'prod';
}
